import React, { memo, ReactNode } from 'react';
import styles from './DeliveryDashboardSideCard.module.scss';
import PIEToggler from '@src/shared/components/PIEToggler';
import { IconChevronLeft } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { DeliveryDashboardScreens } from '../../models/model-enum';
import { useDashboardUIStore } from '../../store/dashboardUIStore';
interface IPropsDeliveryDashboardSideCard {
  children: ReactNode;
  header: ReactNode;
  showBackButton?: Boolean;
  showChevron?: boolean;
  onBackButton?: () => void;
  onTogglerRef?: ({ refs }: any) => void;
  isAbsolute?: Boolean;
  withMargin?: Boolean;
  fullWidth?: Boolean;
  isOpenInitial?: Boolean;
  icon?: ReactNode;
  noSeparator?: Boolean;
  noOverflow?: Boolean;
}

export const DeliveryDashboardSideCard = ({
  children,
  header,
  showBackButton,
  onBackButton,
  onTogglerRef,
  isAbsolute = true,
  withMargin = true,
  fullWidth = false,
  isOpenInitial = true,
  icon,
  noSeparator = false,
  noOverflow = false,
}: IPropsDeliveryDashboardSideCard) => {
  const onBackButtonHandler = (evt: React.MouseEvent) => {
    evt.stopPropagation();
    if (onBackButton) {
      onBackButton();
    }
  };

  const { activeScreen } = useDashboardUIStore();

  return (
    <div
      id="find-me"
      className={`${styles.container} ${isAbsolute ? styles.absolute : ''}  ${
        withMargin ? styles.withMargin : ''
      } ${fullWidth ? styles.fullWidth : ''} ${noOverflow ? styles.noOverflow : ''}`}
    >
      <PIEToggler
        modPanelPadding={!(activeScreen === DeliveryDashboardScreens.COURIER_DETAIL_SCREEN)}
        modSeparator={!noSeparator}
        isOpen={isOpenInitial}
        onOpen={onTogglerRef}
        modChevron={
          !(
            activeScreen === DeliveryDashboardScreens.ORDER_DETAIL_SCREEN ||
            activeScreen === DeliveryDashboardScreens.COURIER_DETAIL_SCREEN
          )
        }
        label={header}
        qaSelector={'delivery-dashboard-side-card-toggler'}
        icon={
          <>
            {showBackButton && !icon && (
              <PIEComponentUtil marginTop="var(--xds-spacing-a)" marginRight="var(--xds-spacing-e)">
                <IconChevronLeft onClick={onBackButtonHandler} size="m" />
              </PIEComponentUtil>
            )}

            {icon}
          </>
        }
      >
        {children}
      </PIEToggler>
    </div>
  );
};

export default memo(DeliveryDashboardSideCard);
